export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      noticeDeliveryInfo: {
        noticeDeliveryAt: 1234567890123,
        serviceName: "アイラ地域サポート",
        deliveryToKbn: 0,
        deliveryStatus: 2,
        deliveryLocationCount: 141,
        openedLocationCount: 41,
        thumbupLocationCount: 39,
        deliverySpCount: 1200,
        openedSpCount: 722,
        thumbupSpCount: 697
      },
      deliveryContents: {
        title: '〇〇大会延期のお知らせ',
        body: '8月20日に予定していた〇〇大会を10月28日に延期します。\n事前準備等のスケジュールについては別途お知らせいたしますので、各係の皆様にはよろしくお願いいたします。',
        attachments: [],
        soundFile: [],
        linkUrl: 'http://www.google.co.jp',
        question: 'xxxxx',
        answerOptions: [],
        keikaiLevel: 0
      },
      deliveryTypeMstUuid: 'deliverytypemst003',
      noticeTypeMstUuid: 'noticeType006',
    }
  }
}